import { useEffect, useState } from 'react';
import { useParticipants } from './ParticipantsContext.js';
import styles from "./Participants.module.css";
import Filter from "../../../components/Filter/Filter.js";
import { ParticipantsLink } from "./ParticipantsLink.js";
import BlackButton from "../../../components/BlackButton/BlackButton.js";

const Participants = () => {
  const { participants, loading, error, fetchParticipants, updateParticipantAttendance
   } = useParticipants();

  const [filteredParticipants, setFilteredParticipants] = useState(participants);
  const [updatingIds, setUpdatingIds] = useState(new Set());
  
  useEffect(() => {
    fetchParticipants();
  }, [fetchParticipants]);

  useEffect(() => {
    setFilteredParticipants(participants);
  }, [participants]);

  const handleSearch = (filters) => {
    let filtered = [...participants];

    if (filters.country) {
      filtered = filtered.filter((p) => p.country === filters.country);
    }
    if (filters.groupName) {
      filtered = filtered.filter((p) =>
        p.groupName?.toLowerCase().includes(filters.groupName.toLowerCase())
      );
    }
    if (filters.playerName) {
      filtered = filtered.filter((p) =>
        p.playerName.toLowerCase().includes(filters.playerName.toLowerCase())
      );
    }
    if (filters.genderLabel) {
      filtered = filtered.filter((p) => p.genderLabel === filters.genderLabel);
    }
    if (filters.attendanceLabel) {
      filtered = filtered.filter(
        (p) => p.attendanceLabel === filters.attendanceLabel
      );
    }

    setFilteredParticipants(filtered);
  };

  const handleAttendanceToggle = async (playerId, currentAttendance) => {
    if (updatingIds.has(playerId)) return;

    const newAttendance = currentAttendance === 1 ? 0 : 1;
    setUpdatingIds((prev) => new Set(prev).add(playerId));

    try {
      const link = new ParticipantsLink();
      await link.updateAttendance(playerId, newAttendance);

      // Context의 원본 데이터 업데이트
      updateParticipantAttendance(playerId, newAttendance);

      // filteredParticipants 업데이트
      setFilteredParticipants((prevList) =>
        prevList.map((p) =>
          p.playerId === playerId
            ? {
                ...p,
                groupEvents: p.groupEvents ? { ...p.groupEvents } : null,
                individualEvents: p.individualEvents
                  ? { ...p.individualEvents }
                  : null,
                attendance: newAttendance,
                attendanceLabel: newAttendance === 1 ? "O" : "X",
              }
            : p
        )
      );

      // 전체 목록 다시 불러오기
      // await fetchParticipants();
    } catch (error) {
      console.error("참가 상태 업데이트 에러:", error);
      alert("참가 상태 업데이트에 실패했습니다.");
    } finally {
      setUpdatingIds((prev) => {
        const newSet = new Set(prev);
        newSet.delete(playerId);
        return newSet;
      });
    }
  };

  // 참가 유무에 따른 className 반환
  const getAttendanceClassName = (attendanceLabel) => {
    if (attendanceLabel === "O") return styles.pos;
    if (attendanceLabel === "X") return styles.neg;
    return "";
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Filter
          onSearch={handleSearch}
          showGroupName={true}
          showGender={true}
          showAttendance={true}
        />
        {/* <BlackButton text="조편성" /> */}
      </div>
      <div className="table-wrap">
          <div className="table-shadow">
            <table>
              <colgroup>
                <col width="3%" />
              </colgroup>
              <thead>
                <tr>
                  <th rowSpan="2">Index</th>
                  <th rowSpan="2">
                    Player
                    <br />
                    No.
                  </th>
                  <th rowSpan="2">Country</th>
                  <th rowSpan="2">Team Name</th>
                  <th rowSpan="2">Player Name</th>
                  <th rowSpan="2">Gender</th>
                  <th rowSpan="2">Position</th>
                  <th colSpan="4">Event (Team)</th>
                  <th colSpan="4">Event (Individual)</th>
                  <th rowSpan="2">Remarks</th>
                  <th rowSpan="2">Status</th>
                </tr>
                <tr>
                  <th>30</th>
                  <th>70</th>
                  <th>90</th>
                  <th>145</th>
                  <th>30</th>
                  <th>70</th>
                  <th>90</th>
                  <th>145</th>
                </tr>
              </thead>
              <tbody>
                {filteredParticipants.map((participant, index) => (
                  <tr key={participant.playerId}>
                    <td>{index + 1}</td>
                    <td>{participant.playerNumber}</td>
                    <td>{participant.country}</td>
                    <td>{participant.groupName}</td>
                    <td>{participant.playerName}</td>
                    <td>{participant.genderLabel}</td>
                    <td>{participant.positionLabel}</td>
                    <td>{participant.groupEvents?.distance30 ?? ""}</td>
                    <td>{participant.groupEvents?.distance70 ?? ""}</td>
                    <td>{participant.groupEvents?.distance90 ?? ""}</td>
                    <td>{participant.groupEvents?.distance145 ?? ""}</td>
                    <td>{participant.individualEvents?.distance30 ?? ""}</td>
                    <td>{participant.individualEvents?.distance70 ?? ""}</td>
                    <td>{participant.individualEvents?.distance90 ?? ""}</td>
                    <td>{participant.individualEvents?.distance145 ?? ""}</td>
                    <td>{participant.note}</td>
                    <td>{participant.attendanceLabel}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="table-gradient"></div>
        </div>
    </>
  );
};
export default Participants;
